module.exports = __webpack_public_path__ + "static/media/clock-regular.72844934.svg";